module.exports = {
    saveFile: (name, type, data) => {
        let blob = new Blob([data], { type: type });

        // IE10+ : (has Blob, but not a[download] or URL)
        if (navigator.msSaveBlob) {
            return navigator.msSaveBlob(blob, name);
        }

        let a = document.createElement("a"),
            url = window.URL.createObjectURL(blob);
        
        document.body.appendChild(a);
        a.style = "display:none";
        a.href = url;
        a.target = "_blank";
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }
}


// WEBPACK FOOTER //
// ./src/helpers/files.js